import Reveal from "@/components/base/Reveal";
import SubscribeForm from "@/components/feature/SubscribeForm";
import { siteInfo } from "@/mocks/news";

const points = [
  { icon: "ri-mail-check-line", text: "每日三档更新，早八点推送当日清单" },
  { icon: "ri-list-check-2", text: "每条标注依据类型，不把线索当结论" },
  { icon: "ri-edit-2-line", text: "支持线索投递与内容纠错，核实后公开更正" },
  { icon: "ri-lock-line", text: "不公开投稿人联系方式，不做二次分发" },
];

export default function SubscribeSection() {
  return (
    <section id="subscribe" className="border-t border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-10 px-4 md:px-8 lg:grid-cols-[1fr_1.15fr] lg:gap-14">
        <Reveal className="w-full">
          <div className="w-full">
            <span className="label-font text-xs uppercase tracking-[0.24em] text-primary-600">
              Subscribe
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              订阅速递，或把线索交给我们
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              如果你只是想吃瓜看真相，订阅每日清单就够了；如果你手上有可核对的记录，欢迎直接写进表单——
              我们会先做交叉验证，再决定是否发布。
            </p>

            <ul className="mt-7 space-y-3.5">
              {points.map((point) => (
                <li key={point.text} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                    <i className={`${point.icon} text-sm`} />
                  </span>
                  <span className="text-sm leading-relaxed text-foreground-700">{point.text}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8 rounded-lg border border-background-200 bg-background-100 p-4">
              <p className="flex items-center gap-2 text-sm text-foreground-800">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-mail-line text-primary-600" />
                </span>
                其他联系方式：{siteInfo.email}
              </p>
              <p className="mt-1.5 pl-7 text-xs text-foreground-500">{siteInfo.replyTime}</p>
            </div>
          </div>
        </Reveal>

        <Reveal className="w-full" delay={80}>
          <SubscribeForm />
        </Reveal>
      </div>
    </section>
  );
}